import { render, staticRenderFns } from "./CompetitionRatingButtons.vue?vue&type=template&id=6d9ca900&scoped=true"
import script from "./CompetitionRatingButtons.vue?vue&type=script&lang=js"
export * from "./CompetitionRatingButtons.vue?vue&type=script&lang=js"
import style0 from "./CompetitionRatingButtons.vue?vue&type=style&index=0&id=6d9ca900&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9ca900",
  null
  
)

export default component.exports